export default {
  profile: "profile",
  profileSetup: {
    cities: "setup/cities",
    counties: "setup/counties",
    countries: "setup/countries",
    postalCodes: "setup/postal-codes",
    levels: "setup/levels",
    types: "profile/specialization/types",
    industryGroup: "profile/workexp/industryGroup",
    certificationClass: "profile/academics/certificationClass",
    certificationCodes: "profile/academics/certificationCodes",
    qualificationCodes: "profile/academics/qualificationCodes",
  },
  ProfileSetupState: (constants) => {
    const obj = {};
    Object.keys(constants).forEach((key) => {
      obj[key] = [];
    });
    return obj;
  },
  settings: "admin/settings",
};
